import computed from './computed'
import data from './data'
import components from './components'

export default {
  computed,
  data,
  components,
  resourcePath: '/v1/dweller/units'
}



// WEBPACK FOOTER //
// ./src/app/tenant/unit/resources/index.js